import { useNavigate } from '@tanstack/react-router';

import { translate } from '../../helpers/translate.helper';
import { IconLogout } from '../../icons/cdl/Logout';
import { useShortcutMenu } from '../hooks/useShortcutMenu';

import { CommandItem } from './CommandItem';

export const Logout = () => {
    const navigate = useNavigate();
    const { setOpen } = useShortcutMenu();

    return (
        <CommandItem
            onSelect={() => {
                navigate({
                    to: '/logout',
                });

                setOpen(false);
            }}
            Icon={IconLogout}
            destructive
        >
            {translate('navigation.signOut')}
        </CommandItem>
    );
};
